import { Button, message } from "antd";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { customerBankService } from "@/api/customerBank";
import { Breadcrumb, ProTable, ZhMessageBox, type ProColumn } from "@/components/common";

interface BankRow {
    id: number;
    type: number;
    name: string;
    account: string;
    bank?: string;
}
const bankTypes = [
    { label: "对公账户", value: 1 },
    { label: "个人账户", value: 2 }
];

/** 银行账户列表支持旧版类型/名称查询和账户维护。 */
export function BankAccountListPage() {
    const navigate = useNavigate();
    const [revision, setRevision] = useState(0);
    const [deleteId, setDeleteId] = useState<number>();
    /** 删除确认及成功提示文案均沿用旧版。 */
    const remove = async () => {
        if (deleteId == null) return;
        await customerBankService.delById(deleteId);
        setDeleteId(undefined);
        setRevision(value => value + 1);
        void message.success("删除成功！");
    };
    const columns = useMemo<ProColumn<BankRow>[]>(
        () => [
            {
                key: "type",
                title: "账户类型",
                width: 170,
                enum: bankTypes,
                search: {
                    key: "type",
                    type: "select",
                    placeholder: "请选择账户类型",
                    options: bankTypes,
                    width: 80,
                    span: 3
                }
            },
            {
                key: "name",
                title: "开户名称/开户人",
                minWidth: 142,
                search: { key: "name", type: "input", placeholder: "请输入开户名称/开户人", width: 120, span: 5 }
            },
            { key: "account", title: "银行卡号", minWidth: 142 },
            { key: "bank", title: "开户行", minWidth: 142 },
            {
                key: "operation",
                title: "操作",
                width: 142,
                fixed: "right",
                render: (_, row) => (
                    <div className="bank-account-actions">
                        <Button type="link" onClick={() => navigate(`/me/bankAccount/edit?id=${row.id}`)}>
                            修改
                        </Button>
                        <Button type="link" onClick={() => setDeleteId(row.id)}>
                            删除
                        </Button>
                    </div>
                )
            }
        ],
        [navigate]
    );
    /** 旧接口返回数组，转换成通用表格的数据合同。 */
    const request = useMemo(
        () => async (params: Record<string, unknown>) => {
            const list = await customerBankService.findByCustomerId(params as never);
            return { list, total: list.length };
        },
        [revision]
    );
    return (
        <section className="bank-account-page section-card">
            <Breadcrumb routes={[{ name: "账号管理" }, { name: "银行账户" }]} />
            <div className="bank-account-table">
                <ProTable
                    key={revision}
                    title="银行账户"
                    rowKey="id"
                    pagination={false}
                    columns={columns}
                    request={request}
                    header={() => (
                        <Button type="primary" onClick={() => navigate("/me/bankAccount/edit")}>
                            新增
                        </Button>
                    )}
                />
            </div>
            <ZhMessageBox
                open={deleteId != null}
                tip="是否删除"
                onCancel={() => setDeleteId(undefined)}
                onSubmit={remove}
            />
        </section>
    );
}
